import { atom } from 'jotai'

import { currentEnv } from '@/env/vars'
import { GET, POST } from '@/utils/fetch'

import { store } from '..'

export const pinnedChatsAtom = atom<string[]>([])

export const setPinnedChats = async (data: string[]) => {
    const res = await POST(`${currentEnv.coreChatUrl}/user/preferences/chats`, { data: { pins: data } })

    if (res) {
        store.set(pinnedChatsAtom, data)
    }

    return res
}
export const getPinnedChats = async () => {
    // Check for existing pinned chats in local storage
    const localPinnedChats = localStorage.getItem('pinnedChats')
    if (localPinnedChats) {
        store.set(pinnedChatsAtom, JSON.parse(localPinnedChats))
        // Save them to the server
        setPinnedChats(JSON.parse(localPinnedChats))
        // remove them from local storage
        localStorage.removeItem('pinnedChats')
    } else {
        // Fetch pinned chats from the server
        const res = await GET<{ data: { pins: [] } }>(`${currentEnv.coreChatUrl}/user/preferences/chats`)

        if (res?.data.pins) {
            store.set(pinnedChatsAtom, res.data.pins)
        }
        return []
    }
}
